export const MAP_DEFAULT_VIEW = {
	center: [80, 22],
	zoom: 5,
};

export const INDIA_MAP_BOUNDS = [
	[52, -2],
	[102, 40],
];

export const TILE_LAYER_URLS = ["a", "b", "c", "d"].map(
	(subdomain) => `https://${subdomain}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png`,
);

export const TILE_LABEL_LAYER_URLS = ["a", "b", "c", "d"].map(
	(subdomain) => `https://${subdomain}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png`,
);

export const TILE_LAYER_ATTRIBUTION =
	'&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions" target="_blank" rel="noreferrer">CARTO</a>';

export const MASTER_POLYGON_STYLE = {
	fill: "#dbeafe",
	stroke: "#1f2937",
	strokeWidth: 0.45,
	strokeOpacity: 0.4,
	fillOpacity: 0.035,
	hoverFill: "#bfdbfe",
	hoverStroke: "#111827",
	hoverStrokeWidth: 0.95,
	hoverStrokeOpacity: 0.75,
	hoverFillOpacity: 0.14,
};

export const COVERAGE_COLORS = {
	0: "#d9d9d9",
	1: "#fee08b",
	2: "#f46d43",
	3: "#1a9850",
};

export const SKATER_BORDER_COLORS = {
	default: "#1f2937",
	top100: "#1f2937",
	hover: "#111827",
};
